/**
 * Encode an adventure ID for use as a single URL path segment.
 * Nested IDs (e.g. events/pilot/host) must be encoded so slashes are not treated as path separators.
 */
export function encodeAdventureIdForPath(adventureId: string): string {
  return encodeURIComponent(adventureId);
}
